import React from "react";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import {connect} from "react-redux";
import { fetchRaces} from "../actions";
import withStyles from "@material-ui/core/styles/withStyles";
import {Typography} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import {getCurrentPoint, getSteps} from "../util/player";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import {HeightMap} from "./HeightMap";

const mapStepToIndex = (stepName,raceName) => {
    const number = parseInt(stepName.replace(/\D/g,'')) + 1;


    if(raceName.includes("40k")){
        return number-14;
    }
    if(raceName.includes("50k")){
        return number-13;
    }
    if(raceName.includes("100k")) {
        return number-8;
    }
    else{
        return number-1;
    }
}



class PlayerStatus extends React.Component{

    constructor(props) {
        super(props);
        this.players = this.props.selected.map((selection) => this.props.race.participants.find(
            (participant) => {
                return selection === participant.bib
            }
        ));
        this.classes = this.props.classes;
        if (props.width === 'xs') {
            this.StepperOrientation = 'vertical';
            this.maxWidthText = "40px"
            this.maxWidthContainer = "100px"
        } else {
            this.StepperOrientation = 'horizontal';
            this.maxWidthText = "none"
            this.maxWidthContainer = "none"
        }
    }

    componentDidMount() {


    }

    handleBack = () => {
        this.setState({activeStep:() => this.state.activeStep - 1});
    };

    handleReset = () => {
        this.setState({activeStep:0});
    };

    renderPlayers = () => {
        return this.players.map((player)=>{
            const steps = getSteps(player)
            const current_point = getCurrentPoint(player)
            const activeStep = mapStepToIndex(current_point,this.props.raceName)
            const stepNames = this.props.checkpoints.map((key)=>{
                return key.name
            });
            return(
                <Grid key={player.bib} item>
                    <Box style={{maxWidth:this.maxWidthContainer,padding:'10px',paddingBottom:'0px',margin:'auto',textAlign:'center'}}  ><Typography  variant={"button"}>{player.name}</Typography></Box>
                    <Stepper style={{paddingLeft:'5px',paddingRight:'5px'}} orientation={this.StepperOrientation}  activeStep={activeStep} alternativeLabel={this.props.width!=='xs'}  >
                        {steps.map((label,index) => {
                            return (
                                <Step key={index}>
                                    <StepLabel style={{minWidth:"38px",minHeight:'60px'}}><Typography style={{maxWidth:this.maxWidthText}} component={"div"} color={"primary"}>{label[1]}</Typography> {stepNames[mapStepToIndex(label[0],this.props.raceName)]}</StepLabel>
                                </Step>
                            )
                        })}
                    </Stepper>
                </Grid>)
        })

    }

    render(){
        return (
        <Grid direction="row" justify={"center"} alignItems="flex-end"  container className={this.classes.root} >
            {this.renderPlayers()}
            {(this.props.width === 'lg' || this.props.width === 'md'|| this.props.width === 'xl') ? <Grid item><HeightMap raceName={this.props.raceName}/></Grid>:null}

        </Grid>
    )
}
}

const useStyles = (theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
});

const mapStateToProps = (state) => {
    return {
        race: state.races
    }
}

export default connect(mapStateToProps,{fetchRaces})(withStyles(useStyles)(withWidth()(PlayerStatus)))
